const getCategoryNavigationByType = (type: 'new' | 'sale' | undefined, i18n: any) => {
  if (!type) {
    return '/c';
  }
  if (type === 'new') {
    return `/c/n/${i18n.t('New').toString().toLowerCase()}`;
  }
  return `/c/s/${i18n.t('Sale').toString().toLowerCase()}`;
};

export default {
  getCategoryNavigationByType,
  getCategoryNavigationByMeta: (meta, i18n: any) => {
    const { isNew, isSale } = meta || {};
    return getCategoryNavigationByType(isNew ? 'new' : (isSale ? 'sale' : undefined), i18n);
  },
};
